import styled from 'styled-components';
import { Select } from 'antd';
import { Caption, Theme } from '@routific/hive';

export const SearchBarLabel = styled.div`
  display: block;
  ${Theme.Typography.BodyStrong.toCssString()}
  margin-bottom: ${Theme.Spacing.xsSpacing};
`;

// !important overrides are required to override Ant Design's inline styles and
// high-specificity selectors on the Select component.
export const StyledSelectDriver = styled(Select)`
  width: 100%;

  .ant-select-selector {
    border: 1px solid ${Theme.Colors.gray4} !important;
    background-color: ${Theme.Colors.gray0} !important;
  }

  &:hover:not(.ant-select-focused):not(.ant-select-disabled) .ant-select-selector {
    border-color: ${Theme.Colors.gray5} !important;
    background-color: ${Theme.Colors.gray1} !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: ${Theme.Colors.primary6} !important;
    background-color: ${Theme.Colors.primary1} !important;
  }

  .ant-select-arrow {
    display: inline-flex;
    align-items: center;
    color: ${Theme.Colors.gray6};
  }

  &.ant-select-focused .ant-select-arrow {
    color: ${Theme.Colors.primary6};
  }

  // Selecting a driver immediately triggers assignment, so there is no
  // persistent "selected value" to display. Hide the selection chip so the
  // search placeholder remains visible at all times.
  .ant-select-selection-item {
    display: none !important;
  }

  .ant-select-selection-placeholder {
    opacity: 1 !important;
  }

  .ant-select-selection-search-input::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }
`;

export const ErrorText = styled(Caption)`
  display: block;
  margin-top: ${Theme.Spacing.xsSpacing};
`;

